<template>
  <div class="order_success_content">
    <div class="order-result-route-info">
      <div>
        <div class="one overflow-ellipsis-line1">
          <span>产品名称：</span>
          <em>{{planInfo.route_plan_name}}</em>
        </div>
        <div class="tow">
          <span>订单编号：</span>
          <em>{{orderInfo.order_info_id}}</em>
        </div>
        <a
          @click="$pushByName('customerOrderDetail',{order_id: orderInfo.order_info_id})"
          href="javascript:void(0);"
        >
          <em>查看订单详情</em>
          <img alt src="~@/assets/images/html/blue_arrow_07.png">
        </a>
      </div>
      <div>
        <div class="one">
          <span>出行日期：</span>
          <em>{{$dateUtil.df(orderInfo.depart_time)}}</em>
        </div>
        <div class="tow">
          <span>订单金额：</span>
          <i>{{orderInfo.total_amount | currency}}</i>
        </div>
      </div>
      <div>
        <div class="one">
          <span>已支付：</span>
          <i>{{paidAmount | currMoney}}</i>
        </div>
        <div class="tow">
          <span>未支付：</span>
          <i>{{unPaidAmount | currMoney}}</i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "payOrderDetail",
  // componentName: 'payOrderDetail',
  data () {
    return {

    }
  },
  created () {
  },
  props: {
    orderInfo: { // 校验属性的类型，如果不带：号得到的肯定是字符串类型 :m='1' :m="true",校验时不能阻断代码的指向，只是警告而已
      type: [Object],
      //default: 0, // 可以给m赋予默认值，如果不传，默认会调用default
      required: true, // 此属性是必须传递，但是不能和default同用。
    },
    planInfo: {
      type: [Object],
      required: true
    },
    paidAmount: {
      type: [Number],
      required: true
    }
  },
  computed: {
    unPaidAmount: function () {
      let numeral = require('numeral');
      return numeral(this.orderInfo.total_amount).subtract(this.paidAmount).value();
    }
  },
  methods: {

  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/pay/components/payOrderDetail.vue